export default __webpack_public_path__ + "static/media/ivy_logo_min.ce42f353.png";